import { InitialDetails } from "@fla/components";

export const initialState: InitialDetails = {
  user: {
    first_name: "",
    last_name: "",
    gender: "",
    job: "",
    line1_address: "",
    suburb: "",
    state: "",
    postcode: "",
    overseas_state: "",
    overseas_country: "",
    dob: "",
    birth_country: "",
    mobile: "",
    email: "",
    comments_relationship: "",

    // income
    user_income_now: "",
    affect_earning_user: "" as any,
    affect_earning_user_details: "",
    user_if_paying_cs: "",
    user_cs_payment_to: "",
    user_cs_payment_amount: "",
    user_cs_payment_other: {
      first_name: "",
      last_name: ""
    },
    user_if_receiving_cs: "" as any,
    user_cs_receiving_from: "",
    user_cs_receiving_amount: "",
    user_cs_receiving_from_other: {
      first_name: "",
      last_name: ""
    }
  },
  spouse: {
    first_name: "",
    last_name: "",
    gender: null,
    job: "",
    line1_address: "",
    suburb: "",
    state: "",
    postcode: "",
    overseas_state: "",
    overseas_country: "",
    dob: "",
    birth_country: "",
    mobile: "",
    email: "",

    // income
    spouse_income_now: "",
    affect_earning_spouse: "" as any,
    affect_earning_spouse_details: "",
    spouse_if_paying_cs: "" as any,
    spouse_cs_payment_to: "",
    spouse_cs_payment_amount: "",
    spouse_cs_payment_other: {
      first_name: "",
      last_name: ""
    },
    spouse_if_receiving_cs: "" as any,
    spouse_cs_receiving_from: "",
    spouse_cs_receiving_amount: "",
    spouse_cs_receiving_from_other: {
      first_name: "",
      last_name: ""
    }
  },
  relationship: {
    living_date: "",
    separation_date: "",
    if_married: "",
    marriage_date: "",
    marriage_city: "",
    marriage_country: "",
    if_divorced: "",
    divorce_date: "",
    divorce_city: "",
    divorce_country: ""
  },
  children: {
    if_children: "",
    child: [],
    if_live_with_anyone: "",
    live_with: [],
    if_live_with_anyone_at_spouse: "",
    live_with_at_spouse: []
  },
  contributions: {
    financial_equal: "",
    financial_contribution: "",
    financial_not_equal_comments: "",
    homemaker_contribution_equal: "" as any,
    contribution_chores: "",
    contribution_chores_comments: "",
    parenting_contribution_equal: "" as any,
    contribution_children_caring: "",
    contribution_children_caring_comments: "",
    contribution_non_financial_equal: "" as any,
    contribution_non_financial: "",
    contribution_non_financial_comments: "",

    significant_gifts: "" as any,
    significant_gifts_details: "",
    inheritance: "" as any,
    inheritance_details: "",
    personal_injury: "" as any,
    personal_injury_details: "",
    workers_comp: "" as any,
    workers_comp_details: "",
    redundancy: "" as any,
    redundancy_details: "",
    winnings: "" as any,
    winnings_details: "",
    welfare_other_children: "" as any,
    welfare_other_children_details: "",
    other_payments: "" as any,
    other_payments_details: ""
  },

  future_needs: {
    acquired_or_disposed: "" as any,
    acquired_or_disposed_details: "",
    health_issues: "" as any,
    health_issues_details: "",
    earning_less_potential: "" as any,
    earning_less_potential_details: "",
    requalify_work: "" as any,
    requalify_work_details: "",
    new_relationship: "" as any,
    new_relationship_details: "",
    primary_caregiver_after_separation: ""
  },
  financial_resources: {
    employment_entitlements: "" as any,
    employment_entitlements_details: "",
    payout_future: "" as any,
    payout_future_details: "",
    if_unpaid_inheritance: "" as any,
    unpaid_inheritance_details: "",
    beneficiary_trust: "" as any,
    beneficiary_trust_details: "",
    cash_life_insurance: "" as any,
    cash_life_insurance_details: ""
  },

  isCompleted: false,
  currentStep: 1
};
